import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TextInput from '../TextInput/TextInput';
import Dropdown from '../Dropdown/Dropdown';
import { stateOptions } from '../Dropdown/stateOptions';
import { ErrorMessage } from 'formik';
import styles from '../../views/Timesheet/Timesheet.module.scss';

export type BasicInfoProps = {
  infoData: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  values?: any;
  isSubmitting?: boolean;
};

const BasicInfo = ({ infoData, errors, touched, handleChange, handleBlur, values, isSubmitting }: BasicInfoProps,) => {

  const [stateSelection, setStateSelection] = useState();
  const [employeeFirstName, setEmployeeNameFirstName] = useState();
  const [employeeLastName, setEmployeeNameLastName] = useState();
  const [email, setEmail] = useState('');
  const [schoolDistrict, setSchoolDistrict] = useState('');
  const [profession, setProfession] = useState('');
  const [department, setDepartment] = useState('');
  const [printDisclaimer, setPrintDisclaimer] = useState(false);

  useEffect(() => {
    infoData({
      state: stateSelection,
      employeeFirstName,
      employeeLastName,
      schoolDistrict,
      profession,
      email: email.trim(),
      department
    });

    // eslint-disable-next-line
  }, [
    stateSelection,
    employeeFirstName,
    employeeLastName,
    schoolDistrict,
    profession,
    department,
    email,
  ]);

  useEffect(() => {
    if (stateSelection === 'CA') {
      setPrintDisclaimer(true);
    } else {
      setPrintDisclaimer(false);
    }
  }, [stateSelection])

  return (
    <Container data-testid="BasicInfo">
      <Row>
        <Col xs={6} md={6} lg={6}>
          <Dropdown
            name='state'
            title="What State Are You Working?"
            required
            onValueChange={setStateSelection}
            options={stateOptions}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.state}
            isFieldInvalid={isSubmitting && errors.state ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="state" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
      </Row>
      <Row>
        <Col>
          <TextInput
            title="Employee First Name"
            required
            onValueChange={setEmployeeNameFirstName}
            name="firstName"
            fieldValidation="required"
            values={values.firstName}
            handleBlur={handleBlur}
            handleChange={handleChange}
            isFieldInvalid={isSubmitting && errors.firstName ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="firstName" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage>
        </Col>
        <Col >
          <TextInput
            title="Employee Last Name"
            required
            onValueChange={setEmployeeNameLastName}
            name="lastName"
            fieldValidation="required"
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.lastname}
            isFieldInvalid={isSubmitting && errors.lastName ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="lastName" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage>
        </Col>
        <Col >
          <TextInput
            title="School District"
            required
            onValueChange={setSchoolDistrict}
            name="schoolDistrict"
            fieldValidation="required"
            type={'text'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.schoolDistrict}
            isFieldInvalid={isSubmitting && errors.schoolDistrict ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="schoolDistrict" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage>
        </Col>
      </Row>
      <Row>
        <Col>
          <TextInput
            title="Department"
            onValueChange={setDepartment}
            name="department"
            // fieldValidation="required"
            values={values.department}
          // handleBlur={handleBlur}
          // handleChange={handleChange}
          // isFieldInvalid={isSubmitting && errors.department ? true : false}
          />
          {/* <ErrorMessage className={styles.ErrorMessageNotice} name="department" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage> */}
        </Col>
        <Col >
          <TextInput
            title="Email"
            required
            onValueChange={setEmail}
            placeholder={'example@example.com'}
            name="email"
            fieldValidation="email"
            type={'email'}
            value={email}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.email.trim()}
            isFieldInvalid={isSubmitting && errors.email ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="email" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage>
        </Col>
        <Col>
          <TextInput
            title="Profession"
            required
            onValueChange={setProfession}
            name="profession"
            fieldValidation="required"
            type={'text'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.profession}
            isFieldInvalid={isSubmitting && errors.profession ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="profession" >
            {msg => <p style={{ color: 'red', fontSize: 12 }}>{msg}</p>}
          </ErrorMessage>
        </Col>
      </Row>
      {
        printDisclaimer &&
        <p style={{ marginTop: 10 }}>
          <b>Note:</b> You qualify for overtime if you work more than 8 hours in a day. A school official must approve this time in advance.
          In Accordance with California State Law, you must be provided with a minimum 30-minute duty free lunch each day you work over 5.0 hours. If you work 6.0 hours or
          less, you may choose to waive the minimum 30-minute lunch.
        </p>
      }
    </Container>
  );
};

export default BasicInfo;
